import { getFirstLine, getSecondLine } from 'src/utils';
import React, { memo, useMemo } from 'react';
import MapLink from './MapLink';
import PhoneLink from '../PhoneLink/PhoneLink';
import useDeliveryInfo from '../Order/hooks/useDeliveryInfo';


const OrderDeliveryInfo = ({ 
  deliveryInfo: deliveryInfoProps, 
  customerInfo, 
  refCode, 
  driverInfo,
  orderUUid = '',
  businessId = '',
  businessUuid = ''
 }) => {

  const {
    deliveryInfo,
    deliveryBy,
    address,
    generateTracingUrl,
    dropOffVerification,
   } = useDeliveryInfo(
      deliveryInfoProps,
      orderUUid,
      businessId,
      businessUuid,
    );

  return (
    <>
      <p className="uppercase delivery-title">Delivery Information:</p>
      <div className="delivery-wrapper">
        <p className="delivery-wrapper-left uppercase">Customer:</p>
        <p className="delivery-wrapper-right">{`${customerInfo?.firstName || ''} ${customerInfo?.lastName || ''}`}</p>
      </div>
      <div className="delivery-wrapper make-padding">
        <p className="delivery-wrapper-left uppercase">Phone:</p>
        <p className="delivery-wrapper-right">
          {customerInfo?.phoneNumber ? (
            <PhoneLink phone={customerInfo.phoneNumber} />
          ) : ''}
        </p>
      </div>
      {deliveryInfo?.addressInfo?.fullAddress && (
        <div className="delivery-wrapper make-padding">
          <p className="delivery-wrapper-left uppercase">Address:</p>

          <MapLink address={address} style={{
            color: '#0066cc',
            textDecoration: 'underline',
            cursor: 'pointer',
            fontWeight: '500'
          }}>
            {deliveryInfo?.addressInfo?.address2
              ? `${getFirstLine(deliveryInfo?.addressInfo?.address1, deliveryInfo?.addressInfo?.address2)} ${getSecondLine(
                deliveryInfo?.addressInfo?.city,
                deliveryInfo?.addressInfo?.state,
                deliveryInfo?.addressInfo?.zipCode,
                true
              )}`
              : `${getFirstLine(deliveryInfo?.addressInfo?.address1)} ${getSecondLine(
                deliveryInfo?.addressInfo?.city,
                deliveryInfo?.addressInfo?.state,
                deliveryInfo?.addressInfo?.zipCode,
                deliveryInfo?.addressInfo?.country,
                true
              )}`}
          </MapLink>
        </div>
      )}  
      {generateTracingUrl && (
        <div className="delivery-wrapper make-padding">
          <p className="delivery-wrapper-left uppercase">Tracking URL:</p>
          <p className="delivery-wrapper-right uppercase" onClick={() => window.open(generateTracingUrl, '_blank')}>
            <a style={{ color: 'rgb(0, 102, 204)' }} href="#" target="_blank" rel="noopener noreferrer">Link</a>
          </p>
        </div>
      )}  
      {
        deliveryBy && (
          <div className="delivery-wrapper make-padding">
            <p className="delivery-wrapper-left uppercase">DELIVERY BY:</p>
            <p className="delivery-wrapper-right">{deliveryBy || ''}</p>
          </div>
        )
      }
      {driverInfo ? (
        <>
          <div className="delivery-wrapper make-padding">
            <p className="delivery-wrapper-left uppercase">Driver name:</p>
            <p className="delivery-wrapper-right">
              {driverInfo?.firstname || ''} {driverInfo?.lastname || ''}
            </p>
          </div>
          {driverInfo?.phoneNumber && (
            <div className="delivery-wrapper make-padding">
              <p className="delivery-wrapper-left uppercase">Driver number:</p>
              <p className="delivery-wrapper-right">
                <PhoneLink phone={driverInfo.phoneNumber} />
              </p>
            </div>
          )}
        </>
      ) : null}
      {
        refCode && (
          <div className="delivery-wrapper make-padding">
            <p className="delivery-wrapper-left uppercase">Reference #:</p>
            <p className="delivery-wrapper-right">{refCode || ''}</p>
          </div>
        )
      }
      {
        (dropOffVerification || deliveryInfo?.deliveryInstructions) && (
          <div className="delivery-wrapper make-padding">
            <p className="delivery-wrapper-left uppercase">Instructions:</p>
            <p className="delivery-wrapper-right" style={{ display: 'flex', flexDirection: 'column' }}>
              {dropOffVerification &&
               <div style={{ fontStyle: 'italic' }}>{dropOffVerification} </div>}
              {deliveryInfo?.deliveryInstructions?.split('\n')?.map((item, index) => {
                if (!item) return null;
                return (
                  <i key={index} style={{ display: 'block' }}>
                    {`"${item}"`}
                  </i>
                );
              })}
            </p>
          </div>
        )
      }
      <hr className="line-header" />
    </>
  )
}

export default memo(OrderDeliveryInfo)